let selColor = '';
let selCat = '';

function getCatalog() {
  return Array.isArray(window.TROVA_SCATOLA_CATALOG) ? window.TROVA_SCATOLA_CATALOG : [];
}

function openLink(url) {
  window.location.href = url;
}

function setColor(v) {
  selColor = v;

  ['cAll', 'cAvana', 'cBianco'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.classList.remove('on');
  });

  const activeId = v === '' ? 'cAll' : v === 'avana' ? 'cAvana' : 'cBianco';
  const activeEl = document.getElementById(activeId);
  if (activeEl) activeEl.classList.add('on');

  doFilter();
}

function setCat(el, v) {
  selCat = v;
  document.querySelectorAll('#catTags .tag').forEach(t => t.classList.remove('on'));
  if (el) el.classList.add('on');
  doFilter();
}

function resetAll() {
  selColor = '';
  selCat = '';

  const fUso = document.getElementById('fUso');
  const fOnda = document.getElementById('fOnda');
  const fMat = document.getElementById('fMat');
  const fL = document.getElementById('fL');
  const fP = document.getElementById('fP');
  const fA = document.getElementById('fA');
  const fTol = document.getElementById('fTol');
  const tolVal = document.getElementById('tolVal');

  if (fUso) fUso.value = '';
  if (fOnda) fOnda.value = '';
  if (fMat) fMat.value = '';
  if (fL) fL.value = '';
  if (fP) fP.value = '';
  if (fA) fA.value = '';
  if (fTol) fTol.value = 5;
  if (tolVal) tolVal.textContent = '±5 cm';

  ['cAll', 'cAvana', 'cBianco'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.classList.remove('on');
  });

  const cAll = document.getElementById('cAll');
  if (cAll) cAll.classList.add('on');

  document.querySelectorAll('#catTags .tag').forEach(t => t.classList.remove('on'));
  const firstCat = document.querySelector('#catTags .tag');
  if (firstCat) firstCat.classList.add('on');

  doFilter();
}

function dimScore(p, fL, fP, fA) {
  let score = 0;
  let n = 0;

  const queries = [
    [fL, p.l],
    [fP, p.pr],
    [fA, p.a]
  ];

  queries.forEach(([q, v]) => {
    if (!isNaN(q) && v) {
      score += Math.abs(v - q);
      n++;
    }
  });

  return n > 0 ? score / n : 999;
}

function cardHtml(p, hasDims, fL, fP, fA) {
  const url = 'https://packandmore.it/products/' + p.h;
  const hasSale = p.cp > 0 && p.cp > p.p;
  const dimLabel = (p.l && p.pr && p.a) ? `${p.l}×${p.pr}×${p.a} cm` : '';
  const isExact = hasDims && dimLabel && dimScore(p, fL, fP, fA) < 2;

  return `<div class="card" onclick="openLink('${url}')">
    <img class="card-img" src="${p.img}" loading="lazy" alt="${escapeHtml(p.t)}" onerror="this.style.display='none'">
    <div class="card-body">
      <div class="card-title">${escapeHtml(p.t)}</div>
      ${dimLabel ? `<div class="card-dims">${dimLabel}</div>` : ''}
      <div class="card-footer">
        <div>
          <div class="card-price">€ ${Number(p.p).toFixed(2)}</div>
          ${hasSale ? `<div class="card-old">€ ${Number(p.cp).toFixed(2)}</div>` : ''}
        </div>
        <div style="display:flex;flex-direction:column;gap:4px;align-items:flex-end">
          ${p.col ? `<span class="card-tag ${escapeAttr(p.col)}">${escapeHtml(p.col)}</span>` : ''}
          ${isExact ? '<span class="match-badge">Misura esatta</span>' : ''}
        </div>
      </div>
    </div>
  </div>`;
}

function renderResults(items, hasDims, fL, fP, fA) {
  const el = document.getElementById('results');
  if (!el) return;

  if (!items.length) {
    el.innerHTML = '<div class="empty"><strong>Nessun risultato</strong>Prova ad allargare la tolleranza dimensioni o rimuovere qualche filtro.</div>';
    return;
  }

  const MAX = 48;
  const shown = items.slice(0, MAX);

  el.innerHTML =
    `<div class="grid">${shown.map(p => cardHtml(p, hasDims, fL, fP, fA)).join('')}</div>` +
    (items.length > MAX
      ? `<p style="text-align:center;font-size:13px;color:var(--color-text-secondary);margin-top:16px;">Mostrati ${MAX} di ${items.length} risultati. Aggiungi altri filtri per restringere.</p>`
      : '');
}

function doFilter() {
  const CATALOG = getCatalog();
  const countLbl = document.getElementById('countLbl');
  const results = document.getElementById('results');

  if (!countLbl || !results) return;

  const uso = document.getElementById('fUso')?.value || '';
  const onda = document.getElementById('fOnda')?.value || '';
  const mat = document.getElementById('fMat')?.value || '';
  const tol = parseInt(document.getElementById('fTol')?.value || '5', 10);

  const fL = parseFloat(document.getElementById('fL')?.value || '');
  const fP = parseFloat(document.getElementById('fP')?.value || '');
  const fA = parseFloat(document.getElementById('fA')?.value || '');

  const hasDims = !isNaN(fL) || !isNaN(fP) || !isNaN(fA);

  const filtered = CATALOG.filter(p => {
    if (uso && !(p.uso || []).includes(uso)) return false;
    if (onda && p.onda !== onda) return false;
    if (mat && p.mat !== mat) return false;
    if (selColor && p.col !== selColor) return false;
    if (selCat && !(p.cats || []).includes(selCat)) return false;

    if (hasDims) {
      if (!p.l && !p.pr && !p.a) return false;

      const dims = [p.l, p.pr, p.a].sort((a, b) => b - a);
      const query = [
        isNaN(fL) ? null : fL,
        isNaN(fP) ? null : fP,
        isNaN(fA) ? null : fA
      ]
        .filter(x => x !== null)
        .sort((a, b) => b - a);

      for (let i = 0; i < query.length; i++) {
        if (typeof dims[i] === 'undefined' || Math.abs(dims[i] - query[i]) > tol) {
          return false;
        }
      }
    }

    return Number(p.p) > 0;
  });

  filtered.sort((a, b) => {
    if (hasDims) {
      return dimScore(a, fL, fP, fA) - dimScore(b, fL, fP, fA);
    }
    return Number(a.p) - Number(b.p);
  });

  countLbl.textContent = filtered.length + ' prodott' + (filtered.length === 1 ? 'o' : 'i');
  renderResults(filtered, hasDims, fL, fP, fA);
}

function escapeHtml(str) {
  return String(str ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

function escapeAttr(str) {
  return String(str ?? '').replace(/[^a-zA-Z0-9_-]/g, '');
}

function initTrovaScatola() {
  if (!document.getElementById('trova-scatola-root')) return;
  doFilter();
}

window.openLink = openLink;
window.setColor = setColor;
window.setCat = setCat;
window.resetAll = resetAll;
window.doFilter = doFilter;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTrovaScatola);
} else {
  initTrovaScatola();
}

document.addEventListener('shopify:section:load', initTrovaScatola);